import { render, staticRenderFns } from "./buymessage.vue?vue&type=template&id=4aac4b86&scoped=true"
import script from "./buymessage.vue?vue&type=script&lang=js"
export * from "./buymessage.vue?vue&type=script&lang=js"
import style0 from "./buymessage.vue?vue&type=style&index=0&id=4aac4b86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aac4b86",
  null
  
)

export default component.exports